import { render, staticRenderFns } from "./StockProductTable.vue?vue&type=template&id=292fa9be"
import script from "./StockProductTable.vue?vue&type=script&lang=js"
export * from "./StockProductTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports